import React from 'react'
import { AvatarWithoutDot } from '@components/Avatar/Avatar'
import { SoundWaveBars } from '@components/SideBars/SpaceSideBar/SoundWaveIcon'
import { Box, MotionBox } from '@ui'
import { AnimatePresence } from 'framer-motion'
import { vars } from 'ui/styles/vars.css'

type Size = 'avatar_sm' | 'avatar_md' | 'avatar_x4' | 'avatar_x10'

export interface SpeakingAvatarProps {
    userId: string
    isSpeaking?: boolean
    size?: Size
}

const avatarToDotSize = {
    avatar_sm: 'x1',
    avatar_x4: 'x1.5',
    avatar_md: 'x2',
    avatar_x10: 'x2.5',
} as const

const avatarToDotSizePixel = {
    avatar_sm: 14,
    avatar_x4: 16,
    avatar_md: 20,
    avatar_x10: 20,
} as const

const avatarToBorderWidth = {
    avatar_sm: 1,
    avatar_md: 2,
    avatar_x4: 2,
    avatar_x10: 2,
} as const

const avatarToAnimation = {
    initial: { opacity: 0.75, scale: 0 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0 },
} as const

export const SpeakingAvatar = React.memo(function SpeakingAvatar(props: SpeakingAvatarProps) {
    const { userId, size = 'avatar_sm', isSpeaking } = props
    const dotSize = avatarToDotSize[size]
    const pixelSize = avatarToDotSizePixel[size]
    const borderWidth = avatarToBorderWidth[size]
    return (
        <Box position="relative">
            <AvatarWithoutDot size={size} userId={userId} />
            <AnimatePresence>
                {isSpeaking && (
                    <MotionBox
                        centerContent
                        position="absolute"
                        right="none"
                        bottom="none"
                        {...avatarToAnimation}
                    >
                        <Box
                            centerContent
                            background="positive"
                            rounded="full"
                            width={dotSize}
                            height={dotSize}
                            style={{
                                boxShadow: `0 0 0 ${borderWidth}px ${vars.color.background.level1}`,
                            }}
                        >
                            <SoundWaveBars animate color="level1" size={pixelSize} />
                        </Box>
                    </MotionBox>
                )}
            </AnimatePresence>
        </Box>
    )
})
